import client from "./client";

/** 내 위치(lat, lng) 기준 반경 이내(기본 1km) 매장 목록을 가까운 순으로 조회한다. 인증 불필요. */
export async function getNearbyStores(lat, lng, radiusKm = 1) {
  const res = await client.get("/store/nearby", { params: { lat, lng, radiusKm } });
  return res.data;
}
